import TransmuxingController from '../core/transmuxing-controller';
import { createDefaultConfig } from '../config';
import TransmuxingEvents from '../core/transmuxing-events';

export const enum VideoCodec {
    H264 = 'H264',
    H265 = 'H265',
}

export const fetchVideoCodec = async (url: string, config?: any): Promise<VideoCodec> => {
    if (!url?.trim()) {
        throw new Error('Invalid Flv URL');
    }

    return new Promise((resolve) => {
        let controller = new TransmuxingController({
            isLive: true,
            type: 'flv',
            url,
            hasAudio: false, // skip audio
        }, Object.assign({}, createDefaultConfig(), { xhrTimeout: 5000 }, config || {}, { enableStashBuffer: false }));

        let timer: ReturnType<typeof setTimeout>;

        const destroy = () => {
            Promise.resolve().then(() => {
                controller?.stop();

                controller?.destroy();

                controller = null;
            });

            timer && clearTimeout(timer);
        };

        controller.on(TransmuxingEvents.IO_ERROR, () => {
            // 网络请求失败（跨域问题、未推流、无网络）
            resolve(VideoCodec.H264);

            destroy();
        });

        controller.on(TransmuxingEvents.DEMUX_ERROR, () => {
            // flv 解码失败（http 数据不符合 flv 标准）
            resolve(VideoCodec.H264);

            destroy();
        });

        controller.on(TransmuxingEvents.LOADING_COMPLETE, () => {
            // flv 加载完成（可能是空文件？）
            resolve(VideoCodec.H264);

            destroy();
        });

        controller.on(TransmuxingEvents.RECOVERED_EARLY_EOF, () => {
            // flv 加载发生中断
            resolve(VideoCodec.H264);

            destroy();
        });

        controller.on(TransmuxingEvents.INIT_DEMUXER, ({ hasVideoTrack }) => {
            // flv 无视频轨道
            if (!hasVideoTrack) {
                resolve(VideoCodec.H264);

                destroy();
            }
        });

        controller.on(TransmuxingEvents.INIT_SEGMENT, (type, { codecEnum }) => {
            if (type === 'video') {
                console.log('=== Video Codec Detected ===', codecEnum);
                resolve(codecEnum);

                destroy();
            }
        });

        // 设置检测超时时间，默认 10s
        timer = setTimeout(() => {
            controller.destroy();

            resolve(VideoCodec.H264);
        }, config?.detectTimeout ?? 10000);

        controller.start();
    });
};
